// All-brands common
import cookieConsent from "../../../../../lib/common/js/components/cookieConsent"
import pipeHeader from "../../../../../lib/common/js/components/pipeHeader"
import pipeFooter from "../../../../../lib/common/js/components/pipeFooter"
import slider from "../../../../../lib/common/js/components/slider"
import goalPace from "../../../../../lib/common/js/components/goalPace"
import customPlan from "../../../../../lib/common/js/components/customPlan"
import circularLoading from "../../../../../lib/common/js/components/circularLoading"
import timer from "../../../../../lib/common/js/components/timer"
import discountScratchCard from "../../../../../lib/common/js/components/discountScratchCard"
import circularCountdownTimer from "../../../../../lib/common/js/components/circularCountdownTimer"
import confettiBg from "../../../../../lib/common/js/components/confettiBg"
import animations from "../../../../../lib/common/js/components/animations"
import commonPaymentsBlock from "../../../../../lib/common/js/components/commonPaymentsBlock"
import email from "../../../../../lib/common/js/components/email"
import personalCommitment from "../../../../../lib/common/js/components/personalCommitment"
import commonUpsell from "../../../../../lib/common/js/components/commonUpsell"
import commonBasicPlanThankYou from "../../../../../lib/common/js/components/commonBasicPlanThankYou"
import primer from "../../../../../lib/common/js/components/primer"
import commonBasicPlanCheckout from "../../../../../lib/common/js/components/commonBasicPlanCheckout"
import frontloadedBasicPlanCheckout from "../../../../../lib/common/js/components/frontloadedBasicPlanCheckout"
import exitIntentListener from "../../../../../lib/common/js/components/exitIntentListener"
import optionsForm from "../../../../../lib/common/js/components/optionsForm"
import heightForm from "../../../../../lib/common/js/components/heightForm"
import weightForm from "../../../../../lib/common/js/components/weightForm"
import targetWeightForm from "../../../../../lib/common/js/components/targetWeightForm"
import commonView from "../../../../../lib/common/js/components/commonView"
import sendOff from "../../../../../lib/common/js/components/sendOff"

// Brand-specific
import brandBasicPlanCheckout from "../../../../../lib/kbm/js/components/brandBasicPlanCheckout"
import discountExpires from "../../../../../lib/kbm/js/components/discountExpires"
import mealPlan from "../../../../../lib/kbm/js/components/mealPlan"
import upsellChat from "../../../../../lib/kbm/js/components/upsellChat"
import upsellPremium from "../../../../../lib/kbm/js/components/upsellPremium"
import upsellShoppingList from "../../../../../lib/kbm/js/components/upsellShoppingList"
import upsellShoppingListAndPremium from "../../../../../lib/kbm/js/components/upsellShoppingListAndPremium"
import upsellWorkouts from "../../../../../lib/kbm/js/components/upsellWorkouts"

// Series specific
import getPipeHeaderConfig from "./getPipeHeaderConfig"
import animationsLoaders from "./animationsLoaders"
import emailWithExitIntent from "./emailWithExitIntent"
import rhetoricalQuestion from "./rhetoricalQuestion"
import discountStep from "./discountStep"

// Components hierarchy and reusage approach:
// Components are defined on 3 different levels depending on the scope of their usage:
// - All-brands common components are placed in the `lib/common/js/components/`.
// - The brand-specific common for all the given brand's series are placed in `lib/[brand]/js/components`.
// - The exact series specific ones are placed here in `src/[brand]-[series]/src/js/components`.
// This array defines the list of components for this exact series by combining them picked
// from different levels to stay DRY and flexible at the same time.
export default [
  { name: "view", data: commonView },
  { name: "cookieConsent", data: cookieConsent },
  { name: "pipeHeader", data: pipeHeader(getPipeHeaderConfig(pipelineConfig.variant)) },
  { name: "pipeFooter", data: pipeFooter },
  { name: "optionsForm", data: optionsForm(commonView) },
  { name: "heightForm", data: heightForm(commonView) },
  { name: "weightForm", data: weightForm(commonView) },
  { name: "targetWeightForm", data: targetWeightForm(commonView) },
  { name: "goalPace", data: goalPace(commonView) },
  { name: "slider", data: slider }, 
  { name: "mealPlan", data: mealPlan },
  { name: "customPlan", data: customPlan(commonView) },
  { name: "circularLoading", data: circularLoading },
  { name: "email", data: email(commonView) },
  { name: "rhetoricalQuestion", data: rhetoricalQuestion },
  { name: "discountStep", data: discountStep },
  { name: "personalCommitment", data: personalCommitment(commonView) },
  { name: "emailWithExitIntent", data: emailWithExitIntent(commonView) },
  { name: "exitIntentListener", data: exitIntentListener },
  { name: "timer", data: timer },
  { name: "animations", data: animations(animationsLoaders) },
  { name: "discountScratchCard", data: discountScratchCard },
  { name: "circularCountdownTimer", data: circularCountdownTimer },
  { name: "confettiBg", data: confettiBg },
  { name: "basicPlanSelection", data: brandBasicPlanCheckout(commonBasicPlanCheckout) },
  { name: "frontloadedBasicPlanCheckout", data: brandBasicPlanCheckout(frontloadedBasicPlanCheckout) },
  { name: "basicPlanPayments", data: brandBasicPlanCheckout(commonBasicPlanCheckout) },
  { name: "frontloadedBasicPlanPayments", data: brandBasicPlanCheckout(frontloadedBasicPlanCheckout) },
  { name: "paymentsBlock", data: commonPaymentsBlock },
  { name: "primer", data: primer },
  { name: "basicPlanThankYou", data: commonBasicPlanThankYou },
  { name: "upsellPremium", data: upsellPremium(commonUpsell) },
  { name: "upsellShoppingList", data: upsellShoppingList(commonUpsell) },
  { name: "upsellWorkouts", data: upsellWorkouts(commonUpsell) },
  { name: "upsellShoppingListAndPremium", data: upsellShoppingListAndPremium(commonUpsell) },
  { name: "upsellChat", data: upsellChat(commonUpsell) },
  { name: "discountExpires", data: discountExpires },
  { name: "sendOff", data: sendOff },
]
